// @ts-nocheck
/* eslint-disable */
import {
  takeLatest,
  take,
  call,
  put,
  fork,
  cancel,
  select,
} from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import * as services from 'utils/apiHelper';
import * as types from 'appRedux/actions/users';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getPermissionRolesToAdmin() {
  const token = localStorage.getItem('token');
  const data = yield call(services.fetchGetApi, `${API_URI}/roles/list`, token);
  if (data) {
    yield put({ type: types.GET_PERMISSION_ROLE_SUCCESS, payload: data });
  }
}

function* getAllUsers(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/user/list?${query}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_ALL_USERS_SUCCESS, payload: data });
  }
}

function* getUserById(action) {
  const token = localStorage.getItem('token');
  const { id } = action;
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/user/user_detail?id=${id}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_USER_BY_ID_SUCCESS, payload: data });
  }
}

function* addUserByAdmin(action) {
  const token = localStorage.getItem('token');
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/user/register_staff`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: types.ADD_USER_SUCCESS, payload: data });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    successToast('User was created successfully.');
  }
}

function* updateStatus(action) {
  const { id } = action;
  const token = localStorage.getItem('token');
  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/user/activate/?id=${id}`,
    '',
    token,
  );

  if (data) {
    yield put({ type: types.UPDATE_USER_STATUS_SUCCESS, payload: data });

    successToast('Status was updated successfully.');
  }
}

function* updateById(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const { id, payload } = action;
  const token = localStorage.getItem('token');
  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/user/user-update/?id=${id}`,
    payload,
    token,
  );
  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    router.navigate('/usermanagement/users');
    successToast('User was updated successfully.');
  }
}

function* deleteUserRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { userId },
  } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/user/user-delete/?id=${userId}`,
    token,
  );

  if (data) {
    yield put({
      type: types.DELETE_USER_SUCCESS,
      userId,
    });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    successToast('User was archived successfully.');
  }
}

function* userMgmtWatcher() {
  yield takeLatest(
    types.GET_PERMISSION_ROLE_REQUEST,
    getPermissionRolesToAdmin,
  );
  yield takeLatest(types.GET_ALL_USERS_REQUEST, getAllUsers);
  yield takeLatest(types.GET_USER_BY_ID_REQUEST, getUserById);
  yield takeLatest(types.ADD_USER_REQUEST, addUserByAdmin);
  yield takeLatest(types.UPDATE_USER_BY_ID_REQUEST, updateById);
  yield takeLatest(types.UPDATE_USER_STATUS_REQUEST, updateStatus);
  yield takeLatest(types.DELETE_USER_REQUEST, deleteUserRequest);
}

export default userMgmtWatcher;
